function getValueFees(key: string, fees: Fee[], defaultValue: number = null): number {
  return (fees.find(fee => fee.name === key) || { value: defaultValue }).value
}

export default getValueFees
